<template>
  <div class="d-flex justify-content-between align-items-center flex-wrap">
    <div class="d-flex flex-column title-cont">
      <h1 class="page-header-1">{{ title }}</h1>
      <h3 class="page-header-2">Viewing {{ dateRange }}</h3>
    </div>
    <PerformanceDashboardFilters />
  </div>
</template>

<script>
import { mapState } from "vuex";

import PerformanceDashboardFilters from "./PerformanceDashboardFilters.vue";

export default {
  components: {
    PerformanceDashboardFilters
  },
  computed: {
    ...mapState({
      dateRange: function ({ dashboardFilters }) {
        return dashboardFilters.base_range;
      },
      title: function ({ dashboardFilters, departments }) {
        if (dashboardFilters.department_id) {
          const dept = departments.find(
            (dept) => dept.id === dashboardFilters.department_id
          );
          return dept ? `${dept.name} Dashboard` : "Company Dashboard";
        }
        return "Company Dashboard";
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.title-cont {
  line-height: 12px;
  h3 {
    font-weight: normal;
  }
}
</style>
